import React from "react";
import { ToolButton } from "./toolButton";
import { useTranslation } from "react-i18next";

interface CommandRowProps {
    title: string;
    selectedId?: string;
    handleAdd?: () => void;
    handleEdit?: () => void;
    handleRemove?: () => void;
}

export const CommandRow = ({
    title,
    selectedId,
    handleAdd,
    handleEdit,
    handleRemove,
}: CommandRowProps) => {
    const { t } = useTranslation();

    return (
        <div className="commandRow">
            <label className="control-label listTitle">{title}</label>
            {!!handleRemove ? (
                <ToolButton
                    title={t("common.remove")}
                    enabled={!!selectedId}
                    classes={"round right remove"}
                    onClick={handleRemove}
                />
            ) : null}
            {!!handleEdit ? (
                <ToolButton
                    title={t("common.edit")}
                    enabled={!!selectedId}
                    classes={"round right edit"}
                    onClick={handleEdit}
                />
            ) : null}
            {!!handleAdd ? (
                <ToolButton
                    title={t("common.add")}
                    enabled
                    classes={"round right add"}
                    onClick={handleAdd}
                />
            ) : null}
        </div>
    );
};
